import styled from 'styled-components'

export const ContainerTabs = styled.div`
	display: flex;
	flex-direction: column;
	margin-right: 10px;
`
export const DivContainer = styled.div`
	margin-left: 20px;
`
